export default "<confirm-authorization\n  ticket=\"vm.ticket\"\n  submit=\"vm.submit()\"\n  reject=\"vm.reject(reasons)\">\n</confirm-authorization>\n";